import {ChangeDetectionStrategy, Component, inject} from '@angular/core';
import {AuthorizedEntityType} from '|api/core';
import {FileDetailService, PermissionSettingsTableComponent} from '|shared';
import {AsyncPipe} from '@angular/common';

@Component({
  selector: 'icz-file-detail-permission-settings',
  templateUrl: './file-detail-permission-settings.component.html',
  styleUrls: ['./file-detail-permission-settings.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [PermissionSettingsTableComponent, AsyncPipe]
})
export class FileDetailPermissionSettingsComponent {

  private fileDetailService = inject(FileDetailService);

  readonly AuthorizedEntityType = AuthorizedEntityType;

  fileId$ = this.fileDetailService.objectId$;

}
